import {RecorderData, RecordType, RecordValueBase} from "../Shared/Shared";
import * as LZString from "../lib/lz-string.min";
import {MousePlayer} from "./PlayerElements/MousePlayer";
import  "es6-promise";
import {ChangePlayer} from "./PlayerElements/ChangePlayer";
import {ScrollPlayer} from "./PlayerElements/ScrollPlayer";
import {KeyboardPlayer} from "./PlayerElements/KeyboardPlayer";
import {AjaxPlayer} from "./PlayerElements/AjaxPlayer";
declare var smartSessionRecordingActions:string[];
declare var smartSessionRootUrl:string;
declare var rnJQuery:any;
declare var smartSessionRecordingInitialProperties:any;
import "jQuery";
import "es6-promise";
import {ResizePlayer} from "./PlayerElements/ResizePlayer";
export class Player {
    actions:RecorderData<any>[]=[];
    currentTime:number=0;
    mousePlayer:MousePlayer;
    changePlayer:ChangePlayer;
    scrollPlayer:ScrollPlayer;
    keyboardPlayer:KeyboardPlayer;
    resizePlayer:ResizePlayer;
    ajaxPlayer:AjaxPlayer;
    initialScrollTop:number=0;
    initialScrollLeft:number=0;
    playerIframe:JQuery;
    iframeContainer:JQuery;
    constructor() {
        AjaxPlayer.DisableAjax();
        this.UncompressRecordData();
        this.iframeContainer=jQuery('#playerContainer',window.parent.document);
        this.playerIframe=jQuery('#playerIframe',window.parent.document);
        jQuery(window.parent.window).resize(()=>{this.AdjustIframeZoom()});
        this.AdjustIframeZoom();


        jQuery(()=>{
            setTimeout(()=>{
                jQuery(document).scrollTop(this.initialScrollTop);
                jQuery(document).scrollLeft(this.initialScrollLeft);
                this.InitializePlayers();
                this.Start();
            },10);

        })

    }
    


    public async Start(){
        for(let record of this.actions)
        {
            if(record.type==RecordType.Move||record.type==RecordType.MouseEnter||record.type==RecordType.MouseLeave||record.type==RecordType.Click)
                this.currentTime=await this.mousePlayer.Execute(this.currentTime,record);

            if(record.type==RecordType.Change)
                this.currentTime=await this.changePlayer.Execute(this.currentTime,record);

            if(record.type==RecordType.Scroll)
                this.currentTime=await this.scrollPlayer.Execute(this.currentTime,record);

            if(record.type==RecordType.KeyValue)
                this.currentTime=await this.keyboardPlayer.Execute(this.currentTime,record);

            if(record.type==RecordType.AjaxReceived)
                this.currentTime=await this.ajaxPlayer.Execute(this.currentTime,record);

            if(record.type==RecordType.Resize)
                this.currentTime=await this.resizePlayer.Execute(this.currentTime,record);
            /*
          await this.scrollPlayer.Execute(200,{time:400, type:RecordType.Scroll,value:{left:0,top:900}});
            await this.scrollPlayer.Execute(200,{time:400, type:RecordType.Scroll,value:{left:0,top:0}});*/
        }
    }

    private UncompressRecordData() {
        for(let actionlist of smartSessionRecordingActions)
            for(let action of actionlist)
                this.actions.push(jQuery.parseJSON(LZString.decompressFromBase64(action)));

        console.log(this.actions);
    }

    private InitializePlayers() {
        this.mousePlayer=new MousePlayer();
        this.changePlayer=new ChangePlayer();
        this.scrollPlayer=new ScrollPlayer(this.initialScrollTop,this.initialScrollLeft);
        this.keyboardPlayer=new KeyboardPlayer();
        this.ajaxPlayer=new AjaxPlayer();
        this.resizePlayer=new ResizePlayer(this);
    }


    public AdjustIframeZoom() {
        let documentWidth=smartSessionRecordingInitialProperties.width;
        let documentHeight=smartSessionRecordingInitialProperties.height;
        let containerWidth=this.iframeContainer.width();
        let containerHeight=this.iframeContainer.height();


        this.playerIframe.height(documentHeight);
        this.playerIframe.width(documentWidth);

        let scale=containerWidth*100/documentWidth/100;

        this.playerIframe.css('transform','scale('+scale+', '+scale+')')
    }
}


(<any>window).SmartSessionRecordingPlayer=new Player();


// WEBPACK FOOTER //
// ./Player/Player.ts